<shared-modal [mobile]="sharedService.screenSize !== 'l'">
  <!-- header -->
  <header class="flex gap-2 items-center w-full" slot="header">
    <h2>Editar template</h2>
    <span
      class="material-symbols-rounded cursor-pointer ml-auto"
      (click)="sharedService.closeModal(route)"
    >
      close
    </span>
  </header>
  <!-- body -->
  <div class="flex flex-col gap-3">
    <input placeholder="Nome" [(ngModel)]="name" [disabled]="loading" />
    <textarea
      placeholder="Texto"
      [(ngModel)]="text"
      class="resize-none h-40"
      [disabled]="loading"
    ></textarea>
    <!-- format with ai -->
    <p class="format-ai">
      Melhore sua mensagem usando Inteligência Artificial.
      @if (!formattingText) {
        <button
          [disabled]="!text || loading"
          (click)="
            formatText();
            analyticsService.logEvent('admin_template_format-message_use_click')
          "
          class="ai p-1"
        >
          <span class="material-symbols-rounded"> auto_awesome </span>
        </button>
      } @else {
        <kor-spinner></kor-spinner>
      }
    </p>
    <!-- images -->
    <hr />
    <h2>Adicionar mídia</h2>
    <blu-media-input
      [(media)]="media"
      folderPath="templates"
      [disabled]="loading"
    ></blu-media-input>
  </div>

  <!-- footer -->
  @if (id) {
    <button
      slot="footer"
      class="tertiary mr-auto"
      (click)="
        deleteTemplate();
        analyticsService.logEvent('admin_delete_template_click')
      "
      [disabled]="loading"
    >
      Deletar
    </button>
  }
  <button
    slot="footer"
    class="secondary"
    (click)="
      copyTemplateUrlToClipboard();
      analyticsService.logEvent('admin_copy_template_link_click')
    "
    [disabled]="loading || !id"
  >
    Copiar link
  </button>
  <button
    [disabled]="!name || formattingText || (!text && !media.length) || loading"
    slot="footer"
    (click)="
      saveTemplate(); analyticsService.logEvent('admin_save_template_click')
    "
  >
    {{ loading ? 'Salvando...' : 'Confirmar' }}
  </button>
</shared-modal>
